module.exports = __webpack_public_path__ + "static/students-e4ecd1e4051ebcac7a07935bb1a86c58.jpg";